import { log } from 'log';

import { POSTCODE_PROVIDER_ERROR } from './constants';
import * as Types from './types';

export const createParsingError = (error: any) => {
    if ('errorCode' in error) {
        return error;
    }

    return {
        ...error,
        errorCode: POSTCODE_PROVIDER_ERROR.PARSE_ERROR,
        errorMessage: 'playtech.mobile.system.form.addressLookupSwiss.serviceError.default'
    };
};

export const createFetchError = (error: any) => {
    if ('errorCode' in error) {
        return error;
    }

    if (error?.name === 'AbortError') {
        return { errorCode: POSTCODE_PROVIDER_ERROR.ABORT_ERROR };
    }

    return { errorCode: POSTCODE_PROVIDER_ERROR.NETWORK_ERROR };
};

export const post = async (url: string, params: Record<string, any>, signal: AbortSignal): Promise<Response> => {
    try {
        const options = {
            method: 'POST',
            signal,
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(params)
        };

        log('httpReq', { url, ...options, time: new Date() });

        return await fetch(url, options);
    } catch (error) {
        throw createFetchError(error);
    }
};

export const getResponseData = async (response: Response): Promise<Types.IAutoCompleteItem[]> => {
    try {
        const data = await response.json() as Types.IAddressLookupResponseData;

        log('httpRes', { data, url: response.url });

        const status = Number.parseInt(data?.QueryAutoComplete2Result?.Status);
        const results = data?.QueryAutoComplete2Result?.AutoCompleteResult || [];

        if (status !== 0) {
            throw {
                errorCode: status
            };
        }

        return results;
    } catch (error) {
        throw createParsingError(error);
    }
};

export const parse = (resp: Types.IAutoCompleteItem[]): Types.IParsedAutoCompleteItem[] => {
    try {
        return resp.map((item) => ({
            zip: item.Zipcode,
            city: item.TownName,
            streetName: item.Streetname,
            houseNumber: item.HouseNumber + item.HouseNumberAddition
        }));
    } catch (error) {
        throw createParsingError(error);
    }
};

export const zipCitySearchResultsToOptions = (searchResults: Types.IParsedAutoCompleteItem[], highlight: string) => {
    return searchResults.map((item, index) => ({
        value: `${item.zip}_${index}`,
        label: `${item.zip} ${item.city}`,
        data: { retrievedAddress: item, highlight }
    }));
};

export const streetSearchResultsToOptions = (searchResults: Types.IParsedAutoCompleteItem[], highlight: string) => {
    return searchResults.map((item, index) => ({
        value: `${item.streetName}_${index}`,
        label: item.streetName,
        data: { retrievedAddress: item, highlight }
    }));
};

export const houseSearchResultsToOptions = (searchResults: Types.IParsedAutoCompleteItem[], highlight: string) => {
    return searchResults.map((item, index) => ({
        value: `${item.houseNumber}_${index}`,
        label: item.houseNumber,
        data: { retrievedAddress: item, highlight }
    }));
};
